/* globals ca */
import { urlToPath } from 'ca-js-helper';

export const projectRoute = (name) => {
    return urlToPath(route(name, [ca.client.base_url, ca.project.slug]));
};

export const isHttps = (url) => {
    const test = url.match('^https://');
    return test;
};

export const testImageUrl = (url) => {
    return new Promise(function (resolve, reject) {
        var image = new Image();
        image.addEventListener('load', resolve);
        image.addEventListener('error', reject);
        image.src = url;
    });
};

export const slugify = (text) => {
    return text.toString().toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '');            // Trim - from end of text
};
